/* eslint-disable import/max-dependencies */
/* eslint-disable sort-keys */
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ScopeProvider } from './scope';
import { RecoilRoot } from 'recoil';
import { BuildConfigProvider, SiteConfigProvider } from '../config';
import { InitLocalization, LocalizationProvider } from '../localization';
import { ImThemeProvider, ImThemeProviderZenith } from '@im/im-theme';
import { MuiProviders } from '@im/ui-lib/theme/MuiProviders';
import { BrowserRouter } from 'react-router-dom';
import { PageLoadMetricsProvider } from './dd-custom-actions/PageLoadMetrics';
import { LogoutConfigProvider } from '../logout';
import { FeatureFlagProvider } from '../feature-flag';
import { CmsFeatureFlagProvider } from '../content';
import { HelmetProviderAsync } from '../content/helmet/HelmetProvider';
import { FavoriteProductsProvider } from './favorite-products';
import { AuthProvider } from '../auth';
import { XvAppId } from '@im/ui-lib/mf-utils';

export type ProviderConfigItem = {
  props?: Record<string, any>;
  provider: React.FC<any>;
};

type AppProviderConfig = {
  [appName: string]: ProviderConfigItem[];
};

type AppProviderProps = {
  basename?: string;
  envVars: any;
  mfOutlets?: any[];
};

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false, // for dev
      retry: 1, // default is 3
    },
  },
});

export const getAppProviders = (
  appId: XvAppId,
  { basename, envVars, mfOutlets = [] }: AppProviderProps
) => {
  const providerConfig: AppProviderConfig = {
    cep: [
      { provider: QueryClientProvider, props: { client: queryClient } },
      { provider: ScopeProvider, props: { scope: 'cep_app' } },
      { provider: RecoilRoot },
      {
        provider: BuildConfigProvider,
        props: { envVars, mfOutlets },
      },
      { provider: SiteConfigProvider },
      { provider: LocalizationProvider },
      { provider: ImThemeProvider },
      { provider: MuiProviders },
      { provider: BrowserRouter, props: { basename } },
      { provider: PageLoadMetricsProvider },
      { provider: AuthProvider },
      { provider: InitLocalization },
      { provider: LogoutConfigProvider },
      { provider: FeatureFlagProvider },
      { provider: CmsFeatureFlagProvider },
      { provider: HelmetProviderAsync },
      { provider: FavoriteProductsProvider },
    ],

    x4ec: [
      { provider: QueryClientProvider, props: { client: queryClient } },
      { provider: ScopeProvider, props: { scope: 'x4ec_app' } },
      { provider: RecoilRoot },
      {
        provider: BuildConfigProvider,
        props: { envVars, mfOutlets },
      },
      { provider: SiteConfigProvider },
      { provider: LocalizationProvider },
      { provider: ImThemeProviderZenith },
      { provider: MuiProviders },
      { provider: BrowserRouter, props: { basename } },
      { provider: AuthProvider },
      { provider: InitLocalization },
      { provider: LogoutConfigProvider },
      { provider: FeatureFlagProvider },
      { provider: HelmetProviderAsync },
    ],
  };
  return providerConfig[appId];
};
